import { Card, CardContent } from "@/components/ui/Card";
import { AppointmentLocation } from "@/components/ui/AppointmentLocation";
import type { AppointmentTimeZone } from "@/api/enums";
import {
  formatAppointmentTime,
  formatWeekdayLong,
} from "@/utils/date";

interface AppointmentDetailsCardProps {
  doctorName: string;
  appointmentDate: string;
  locationAddress?: string;
  isTelehealth: boolean;
  timeZone?: AppointmentTimeZone;
}

export function AppointmentDetailsCard({
  doctorName,
  appointmentDate,
  locationAddress,
  isTelehealth,
  timeZone,
}: AppointmentDetailsCardProps) {
  return (
    <Card className="mb-6">
      <CardContent className="p-6">
        <h2 className="headline text-xl text-foreground mb-4">
          Appointment Details
        </h2>
        <div className="space-y-2">
          <div className="flex items-center gap-2">
            <span className="body-copy text-sm text-muted-foreground font-medium">
              Doctor:
            </span>
            <span className="body-copy text-sm text-foreground">
              {doctorName}
            </span>
          </div>
          <div className="flex items-center gap-2">
            <span className="body-copy text-sm text-muted-foreground font-medium">
              Date:
            </span>
            <span className="body-copy text-sm text-foreground">
              {formatWeekdayLong(appointmentDate)} at{" "}
              {formatAppointmentTime(appointmentDate, timeZone)}
            </span>
          </div>
          <AppointmentLocation
            address={locationAddress}
            isTelehealth={isTelehealth}
          />
        </div>
      </CardContent>
    </Card>
  );
}
